/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

// import change pic
import InputerTrackingPengajuanList from '../views/tracking-pengajuan/InputerTrackingPengajuanList.vue';
import InputerTrackingPengajuanDetail from '../views/tracking-pengajuan/InputerTrackingPengajuanDetail.vue';

import { setBreadcrumb } from './index';

const inputerTrackingPengajuanRoute = {
  path: '/inputer-tracking-pengajuan',
  name: 'InputerTrackingPengajuan',
  meta: {
    title: 'BNI QRIS - Inputer Tracking Pengajuan',
    appBarTitle: 'Inputer Tracking Pengajuan',
  },
  component: Parent,
  children: [
    {
      path: '/inputer-tracking-pengajuan/list',
      meta: {
        title: 'BNI QRIS - List Inputer Tracking Pengajuan',
        appBarTitle: 'List Inputer Tracking Pengajuan',
        breadcrumbs: () => [
          setBreadcrumb(
            'inputer tracking pengajuan',
            '/inputer-tracking-pengajuan',
            true
          ),
          setBreadcrumb('list pengajuan', '/inputer-tracking-pengajuan/list'),
        ],
      },
      component: InputerTrackingPengajuanList,
      name: 'InputerTrackingPengajuanList',
    },
    {
      path: '/inputer-tracking-pengajuan/list/view/:id(\\d+)',
      meta: {
        title: 'BNI QRIS - View Detail',
        appBarTitle: 'View Detail',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb(
              'inputer tracking pengajuan',
              '/inputer-tracking-pengajuan',
              true
            ),
            setBreadcrumb('list pengajuan', '/inputer-tracking-pengajuan/list'),
            setBreadcrumb(
              'view',
              '/inputer-tracking-pengajuan/list/view',
              true
            ),
            setBreadcrumb(
              `${id}`,
              `/inputer-tracking-pengajuan/list/view/${id}`,
              true
            ),
          ];
        },
      },
      component: InputerTrackingPengajuanDetail,
      name: 'InputerTrackingPengajuanDetail',
    },
  ],
};

export default inputerTrackingPengajuanRoute;
